import { useContext } from 'react';
import createNamedContext from 'utils/createNamedContext';

export type RegionAuthorizedMap = Partial<Record<General.Region, boolean>>;

export interface MarektingContextValue {
  regionAuthorizedMap: RegionAuthorizedMap;
  setRegionAuthorizedMap: React.Dispatch<React.SetStateAction<RegionAuthorizedMap>>;
}

export const MarketingContext = createNamedContext<MarektingContextValue | null>(
  'MarektingContext',
  null,
);

export const useMarketing = () => {
  const value = useContext(MarketingContext);

  if (value === null) {
    throw new Error('useMarketing() may be used only in the context of a <Marketing /> component.');
  }

  return value;
};

export default MarketingContext.Provider;
